import TextBookAddWordArea from "@/pages/comp/plan/word/word_inside/common/add_word";

function TextBookAddWordPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    word_type: "",
    ...props
  };

  return (
    <div>
      <TextBookAddWordArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        g_par_id={myProps.g_par_id}
        g_par_seq={myProps.g_par_seq}
        word_type={myProps.word_type}
      ></TextBookAddWordArea>
    </div>
  );
};
export default TextBookAddWordPopupArea;